import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import './App.css';
import Home from './pages/HomePage';
import SubCategory from "./pages/SubCategoryPage";
import OnlineTest from "./pages/OnlineTestPage";
import TestResult from "./pages/TestResultPage";
import TestSolution from "./pages/TestSolutionPage";
import Signup from "./pages/SignupPage";
import Login from "./pages/LoginPage";
import AboutUs from "./pages/AboutUsPage";
import ActivationMail from "./pages/ActivationMailPage";
import ChangePassword from "./pages/ChangePasswordPage";
import FAQs from "./pages/FaqsPage";
import ForgetPassword from "./pages/ForgetPasswordPage";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import ResetPassword from "./pages/ResetPasswordPage";
import UserActivation from "./pages/UserActivationPage";
import UserProgress from "./pages/UserProgressPage";
import GoToTop from "./components/GoToTop";
import AllExams from "./pages/AllExamsPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import Navbar from './components/Navbar';           // ensure import
import Footer from './components/Footer'; // ensure import
import { GoogleOAuthProvider } from "@react-oauth/google";

// PageWrapper: simple motion wrapper for route content
const PageWrapper = ({ children, duration = 0.36 }) => {
  const variants = {
    initial: { opacity: 0, y: 12, scale: 0.995 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -8, scale: 0.995 }
  };

  return (
    <motion.main
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration }}
      style={{ minHeight: '100%', width: '100%' }}
    >
      {children}
    </motion.main>
  );
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>

        <Route path = "/" exact element={ <PageWrapper><Home /></PageWrapper> } />
        <Route path = "/practice-test-exam-prep/">
          <Route path=":catName" element = {<PageWrapper><SubCategory /></PageWrapper>} />
        </Route>
        <Route path = "/online-practice-test/"> 
           <Route path=":id" element = {<PageWrapper><OnlineTest /></PageWrapper>} />   
        </Route>
        <Route path = "/online-practice-test-result/"> 
           <Route path=":id" element = {<PageWrapper><TestResult /></PageWrapper>} />   
        </Route>
        <Route path = "/online-quiz-test-answers/"> 
           <Route path=":id" element = {<PageWrapper><TestSolution /></PageWrapper>} />   
        </Route>   
        <Route path = "/auth/password-reset/"> 
           <Route path=":code" element = {<PageWrapper><ResetPassword /></PageWrapper>} />   
        </Route>  
        <Route path = "/auth/user-activation/"> 
           <Route path=":code" element = {<PageWrapper><UserActivation /></PageWrapper>} />   
        </Route> 
        <Route path = "/register" exact element={ <PageWrapper><Signup /></PageWrapper> } />
        <Route path = "/login" exact element={ <PageWrapper><Login /></PageWrapper> } />
        <Route path = "/about" exact element={ <PageWrapper><AboutUs /></PageWrapper> } />
        <Route path = "/auth/resend-activation-mail" exact element = {<PageWrapper><ActivationMail /></PageWrapper> } />
        <Route path = "/auth/change-user-password" exact element = {<PageWrapper><ChangePassword /></PageWrapper> } />
        <Route path = "/frequently-asked-questions" exact element = {<PageWrapper><FAQs /></PageWrapper> } />
        <Route path = "/auth/reset-forgot-password" exact element = {<PageWrapper><ForgetPassword /></PageWrapper> } />
        <Route path = "/privacy-policy" exact element = {<PageWrapper><PrivacyPolicy /></PageWrapper> } />
        <Route path = "/check-user-progress/" exact element = {<PageWrapper><UserProgress /></PageWrapper> } />
        <Route path = "/all-exam-prep-practice-test" exact element = {<PageWrapper><AllExams /></PageWrapper> } />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/subscribe-practice-test/:slug" element={<PageWrapper><SubscriptionPage /></PageWrapper>} />
        
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim();
  const appShell = (
    <Router>
      <GoToTop />
      <Navbar />             {/* STATIC: stays outside animation */}
      <AnimatedRoutes />
      <Footer />       {/* STATIC: stays outside animation */}
    </Router>
  );

  if (!googleClientId) {
    return appShell;
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      {appShell}
    </GoogleOAuthProvider>
  );
}

export default App;
